<template>
  <Layout>
    <PageHeader />
    <div
      class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
    >
      <h5 class="card-title mb-0 text-white">Cadastrar participante</h5>
    </div>
    <div class="card-body">
      <CadastrarUsuario />
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import CadastrarUsuario from '@/components/administration/users/CadastrarUsuario.vue'

export default {
  name: 'Users',

  components: {
    Layout,
    PageHeader,
    CadastrarUsuario,
  },

  data() {
    return {
      title: 'Cadastrar participante',
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },
}
</script>
